/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { orders as ordersPortal } from '../../../queries';

import Item from '../../../components/Orders/Item';
import Loading from '../../../components/Loading/Page';
import { EmptyList } from '../../../assets/styles';

class PendingOrders extends Component {
  state = {
    selected: new Map(),
    itemsCount: null,
    orders: null,
    loading: true,
    offset: 0,
    isLoading: false,
    hasMore: true,
  }

  componentDidUpdate = () => {
    if (!this.props.data.loading && this.state.itemsCount === null) {
      this.props.handleItemsCount(this.props.data.ordersPortal.total);

      this.setState({
        orders: this.props.data.ordersPortal.orders,
        loading: false,
        itemsCount: this.props.data.ordersPortal.total || 0,
      });
    }
  }

  handleFilter = () => {
    this.setState({
      selected: new Map(),
      itemsCount: null,
      offset: 0,
      isLoading: false,
      loading: true,
      hasMore: true,
    });
  }

  fetchMore = () => {
    if (this.state.orders && this.state.orders.length >= 10 && this.state.hasMore) {
      this.setState(state => ({ offset: state.offset + 10, isLoading: true }));

      this.props.data.fetchMore({
        variables: {
          storeId: this.props.store.id,
          status: 'waiting',
          searchBy: this.props.searchBy,
          orderBy: this.props.filterValue.value !== 'Data'
            ? { type: this.props.filterValue.value }
            : {
              type: this.props.filterValue.value,
              startDate: this.props.filterValue.startDate,
              endDate: this.props.filterValue.endDate,
            },
          offset: this.state.offset,
          limit: 10,
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          this.setState({ isLoading: false });

          if (fetchMoreResult.ordersPortal.orders.length === 0) {
            this.setState({ hasMore: false });
          }

          this.setState(prevState => ({
            orders: [...prevState.orders, ...fetchMoreResult.ordersPortal.orders],
          }));
        },
      });
    }
  }

  refetchQueries = () => {
    this.props.data.fetchMore({
      variables: {
        storeId: this.props.store.id,
        status: 'waiting',
        searchBy: this.props.searchBy,
        orderBy: this.props.filterValue.value !== 'Data'
          ? { type: this.props.filterValue.value }
          : {
            type: this.props.filterValue.value,
            startDate: this.props.filterValue.startDate,
            endDate: this.props.filterValue.endDate,
          },
        offset: 0,
        limit: this.state.offset === 0 ? 10 : (this.state.offset + 10),
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.props.handleItemsCount(fetchMoreResult.ordersPortal.total);

        this.setState({
          orders: fetchMoreResult.ordersPortal.orders,
          itemsCount: fetchMoreResult.ordersPortal.total,
          hasMore: true,
        });
      },
    });
  }

  onPressItem = (id) => {
    this.setState((state) => {
      const selected = new Map(state.selected);
      selected.set(id, !selected.get(id));
      return { selected };
    });
  };

  render() {
    const { orders, loading, isLoading } = this.state;

    return (
      <div ref={(ref) => { this.pendingOrders = ref; }}>
        {loading && <Loading size={8} margin="1px" />}
        {!loading && (
          <div>
            {orders && orders.length === 0 ? (
              <EmptyList>
                <p>Nenhum pedido encontrado</p>
              </EmptyList>
            ) : (
              <>
                {orders.map(item => (
                  <Item
                    key={item._id}
                    id={item._id}
                    item={item}
                    onPressItem={this.onPressItem}
                    selected={!!this.state.selected.get(item._id)}
                    openCancelOrderModal={this.props.openCancelOrderModal}
                    store={this.props.store}
                    refetchQueries={this.refetchQueries}
                  />
                ))}
              </>
            )}
            {isLoading && <Loading size={8} margin="1px" />}
          </div>
        )}
        <BottomScrollListener offset={100} onBottom={this.fetchMore} />
      </div>
    );
  }
}

export default graphql(ordersPortal, {
  withRef: true,
  options: props => ({
    fetchPolicy: 'no-cache',
    variables: {
      storeId: props.store.id,
      status: 'waiting',
      searchBy: props.searchBy,
      orderBy: props.filterValue.value !== 'Data'
        ? { type: props.filterValue.value }
        : {
          type: props.filterValue.value,
          startDate: props.filterValue.startDate,
          endDate: props.filterValue.endDate,
        },
      offset: 0,
      limit: 10,
    },
  }),
})(PendingOrders);
